import React from "react"

import { NavTabs, TabContent, TabPane } from "components/anti/tabs/tabs"
import { Card } from "components/anti/card/card"
import { useScrollAnim } from "src/components/hooks/hooks"


export const CommissionersAndDirectorsList = ({
    commissioners,
    directors,
    nominationAndRemunerationCommittee,
    auditCommittee,
}) => {
    const [trigger, anim] = useScrollAnim()

    const groups = [
        { data: commissioners, target: "commissioners" },
        { data: directors, target: "directors" },
        { data: auditCommittee, target: "audit-committee" },
        {
            data: nominationAndRemunerationCommittee,
            target: "nomination-remuneration-committee",
        },
    ].filter(({ data }) => data?.title && data?.list?.length)

    if (!groups.length) return null

    return (
        <section className="py-main sc-cnd-list" ref={trigger}>
            <div className="container">
                <NavTabs
                    data={groups.map(({ data, target }) => ({
                        name: data.title,
                        target: target,
                    }))}
                    scrollable="true"
                    className="cnd-tabs justify-content-center"
                />
                <TabContent>
                    {groups.map(({ data, target }, groupIndex) => {
                        return (
                            <TabPane
                                id={target}
                                className={groupIndex === 0 ? "active" : ""}
                                key={target}
                            >
                                <h2 className={`py-4 ${anim(1)}`}>{data.title}</h2>
                                <div className="row row-3">
                                    {data.list.map((person, i) => {
                                        return (
                                            <div className="col-6 col-md-2" key={i}>
                                                <Card
                                                    variant="boxless"
                                                    img={person.image?.sourceUrl}
                                                    imgRatio="r-3-4"
                                                    title={person.title}
                                                    text={person.label}
                                                    titleClassName="h5"
                                                    cardBodyClassName="px-0"
                                                    className={`${anim(2 + i)}`}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                            </TabPane>
                        )
                    })}
                </TabContent>
            </div>
        </section>
    )
}
